// extracted by mini-css-extract-plugin
export default {"container":"CopyButton_container__kqHSk","flex":"CopyButton_flex__DMdNo","icon":"CopyButton_icon__KxZVY"};